import { type Load as CoreLoad } from 'core/domain/Load'
import { getFormattedRatePerMile } from 'core/presenters/loadPresenter'

import { type Load } from './Load'
import { type Offer } from './Offer'

export type ActiveOffer = Omit<Offer, 'load'>

export type LoadOffer = Load & {
  activeOffer?: ActiveOffer | null
}

export const enum BookingType {
  BookNow = 'BookNow',
  BidAward = 'BidAward',
  BidCounter = 'BidCounter',
  BidTooHigh = 'BidTooHigh',
}

export type BookingOffer = {
  id: string
  triggerContext: string
  position?: number
  bookingType: BookingType
}

export const enum OfferType {
  Contracted = 'Contracted',
  Vip = 'VIP',
  Regular = 'Regular',
}

export function getLoadOfferType(loadOffer?: LoadOffer): OfferType {
  if (!loadOffer) {
    return OfferType.Regular
  }

  const isContracted = Boolean(loadOffer.activeOffer?.contract)
  const isDaimlerVIP = Boolean(loadOffer.activeOffer?.daimlerVip)

  if (isContracted) {
    return OfferType.Contracted
  }

  if (isDaimlerVIP) {
    return OfferType.Vip
  }

  return OfferType.Regular
}

export function getLoadBookingType(
  offerType: OfferType,
  isBidAward: boolean = false,
  isBidCounter: boolean = false
): BookingType {
  if (isBidCounter) {
    return BookingType.BidCounter
  }

  if (isBidAward) {
    return BookingType.BidAward
  }

  return BookingType.BookNow
}

export function getRatePerMileFromLoadOffer(
  loadOffer: LoadOffer,
  price?: number
): string | undefined {
  if (!price || !loadOffer) return undefined
  return getFormattedRatePerMile({
    flatRate: String(price),
    mileage: Number(loadOffer.mileage),
  } as CoreLoad)
}
